/**
 * gbpLabels — GBP ekranlarının ortak Türkçe etiketleri.
 *
 * Aynı sözlük hem lokasyon tablosunda/Excel çıktısında hem detay penceresinde
 * kullanılıyor; iki kopya tutulursa biri güncellenip diğeri unutuluyor.
 */

export const DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export const DAY_TR = {
  MONDAY: 'Pazartesi', TUESDAY: 'Salı', WEDNESDAY: 'Çarşamba', THURSDAY: 'Perşembe',
  FRIDAY: 'Cuma', SATURDAY: 'Cumartesi', SUNDAY: 'Pazar',
};

export const MEDIA_CATEGORY_TR = {
  COVER: 'Kapak', PROFILE: 'Profil', LOGO: 'Logo', EXTERIOR: 'Dış mekân',
  INTERIOR: 'İç mekân', PRODUCT: 'Ürün', AT_WORK: 'İş başında',
  FOOD_AND_DRINK: 'Yiyecek & içecek', MENU: 'Menü', COMMON_AREA: 'Ortak alan',
  ROOMS: 'Odalar', TEAMS: 'Ekip', ADDITIONAL: 'Diğer', STOREFRONT: 'Vitrin',
};

export const catTR = (c) => MEDIA_CATEGORY_TR[c] || c || 'Diğer';

// Kapak ve kimlik kareleri önce; galeri Google'daki sırayla değil anlamlı sırayla
export const MEDIA_CATEGORY_ORDER = [
  'COVER', 'LOGO', 'PROFILE', 'EXTERIOR', 'STOREFRONT', 'INTERIOR', 'PRODUCT',
  'AT_WORK', 'FOOD_AND_DRINK', 'MENU', 'COMMON_AREA', 'ROOMS', 'TEAMS', 'ADDITIONAL',
];

export const statusTR = (s) => (
  s === 'OPEN' ? 'Açık'
    : s === 'CLOSED_PERMANENTLY' ? 'Kalıcı kapalı'
      : s === 'CLOSED_TEMPORARILY' ? 'Geçici kapalı'
        : s || ''
);
